import React, { useState } from "react";
import { Modal, Typography, Button, Divider, message } from "antd";
import { CalculatorOutlined } from "@ant-design/icons";
import { calculateMonthlyPrincipalAndInterest, canCalculate } from "../features/helpers/netsheetAmtCalculater";

const { Title, Text, Paragraph } = Typography;

function AmortizingLoanPopoverModal({ setModalState, modalState, rootDocData, accessToken, currentUrlId, handleInputSave }) {
  const [confirmLoading, setConfirmLoading] = useState(false);
        let LoanAmortizationPeriodElement = document.getElementById("LoanAmortizationPeriod");
        let AnnualIntRatePercentElement = document.getElementById("AnnualIntRatePercent");
        let PrincipalLoanAmountElement = document.getElementById("PrincipalLoanAmount");
        let MonthlyPrincipalAndInterestAmtElement = document.getElementById("MonthlyPrincipalAndInterestAmt");

        let LoanAmortizationPeriod = LoanAmortizationPeriodElement?.value || "0.00"; // Yearly n = numberOfPaymentsToMake , LoanAmortizationPeriod
        let AnnualIntRatePercent = AnnualIntRatePercentElement?.value || "0.00"; // Yearly i = AnnualIntRatePercent
        let PrincipalLoanAmount = PrincipalLoanAmountElement?.value || "0.00"; // P = LoanAmount = Principal


    const handleOk = () => {
        // // STEP 1 > GET ELEMENTS BY ID:-
        // let LoanAmortizationPeriodElement = document.getElementById("LoanAmortizationPeriod");
        // let AnnualIntRatePercentElement = document.getElementById("AnnualIntRatePercent");
        // let PrincipalLoanAmountElement = document.getElementById("PrincipalLoanAmount");
        // let MonthlyPrincipalAndInterestAmtElement = document.getElementById("MonthlyPrincipalAndInterestAmt");

        // // STEP 2 > GET VALUES:-
        // let LoanAmortizationPeriod = LoanAmortizationPeriodElement?.value || "0.00"; // Yearly n = numberOfPaymentsToMake , LoanAmortizationPeriod
        // let AnnualIntRatePercent = AnnualIntRatePercentElement?.value || "0.00"; // Yearly i = AnnualIntRatePercent
        // let PrincipalLoanAmount = PrincipalLoanAmountElement?.value || "0.00"; // P = LoanAmount = Principal

        // STEP 3 > VALIDATE & CALCULATE:-
        if (LoanAmortizationPeriod && AnnualIntRatePercent && PrincipalLoanAmount && canCalculate(PrincipalLoanAmount, AnnualIntRatePercent, LoanAmortizationPeriod)) {
            let MonthlyPrincipalAndInterestAmt = calculateMonthlyPrincipalAndInterest({ numberOfPaymentsToMake: LoanAmortizationPeriod, AnnualIntRatePercent, Principal: PrincipalLoanAmount });
            if (MonthlyPrincipalAndInterestAmt && MonthlyPrincipalAndInterestAmtElement?.name) {
                let specificData = { [MonthlyPrincipalAndInterestAmtElement?.name]: MonthlyPrincipalAndInterestAmt };
                let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
                localData = {
                    ...localData,
                    ...specificData,
                };
                localStorage.setItem(currentUrlId, JSON.stringify(localData));
                handleInputSave(specificData);

                // CLOSE MODAL
                setConfirmLoading(true);
                setTimeout(() => {
                    setConfirmLoading(false);
                    setModalState((prevState) => ({ ...prevState, amortizingLoanPopoverModal: false }));
                }, 1000);
            }
        } else {
            [LoanAmortizationPeriodElement, AnnualIntRatePercentElement, PrincipalLoanAmountElement].forEach((el) => {
                if (el) {
                    el.style.backgroundColor = "yellow";
                    el.style.animation = "fadeRed 1s ease-in-out";
                    setTimeout(() => {
                        el.style.animation = "";
                        el.style.backgroundColor = "";
                    }, 3000);
                }
            });
            setModalState((prevState) => ({ ...prevState, amortizingLoanPopoverModal: false }));
            message.error("Please enter valid Loan Amount, Interest Rate and Amortization Period to calculate Monthly Principal & Interest.");
        }
    };

    const handleCancel = () => {
        setModalState((prevState) => ({ ...prevState, amortizingLoanPopoverModal: false }));
    };

    return (
        <>
            <Modal
                visible={true}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Calculate"
                confirmLoading={confirmLoading}
                // width={600}
                centered
            >
                <div>
                    <Title level={4} style={{ color: "#085191", textAlign: "center" }}>
                        Standard Amortizing Loan Formula
                    </Title>

                    <div
                        style={{
                            backgroundColor: "#f0f8ff",
                            border: "1px solid #d6e4ff",
                            padding: "12px",
                            borderRadius: "8px",
                            margin: "16px 0",
                            fontSize: "16px",
                            textAlign: "center",
                            fontFamily: "monospace",
                        }}
                    >
                        M = P × [ i(1 + i)<sup>n</sup> ] / [ (1 + i)<sup>n</sup> – 1 ]
                    </div>

                    <Paragraph style={{ marginBottom: 8 }}>
                        <Text strong>M :</Text> Monthly payment → Need to be calculated
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 8 }}>
                        <Text strong>P :</Text> Principal loan amount → <strong>{PrincipalLoanAmount}</strong>
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 8 }}>
                        <Text strong>i &nbsp;:</Text> Monthly interest rate (Annual ÷ 12) → <strong>{AnnualIntRatePercent} ÷ 12 = {(parseFloat(AnnualIntRatePercent) / 100 / 12).toFixed(6)}</strong>
                    </Paragraph>
                    <Paragraph style={{ marginBottom: 8 }}>
                        <Text strong>n :</Text> Total number of monthly payments (Years × 12) → <strong>{LoanAmortizationPeriod} × 12 = {parseFloat(LoanAmortizationPeriod) * 12}</strong>
                    </Paragraph>

                    <Divider />

                    <Paragraph>
                        Use this formula to calculate the monthly installment for a loan
                        based on the principal amount, interest rate, and term.
                    </Paragraph>
                </div>
            </Modal>
        </>
    );
}

export default AmortizingLoanPopoverModal;
